import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Input from '../../../components/ui/Input';
import Select from '../../../components/ui/Select';
import Button from '../../../components/ui/Button';

const SearchAndSort = ({ 
  searchQuery, 
  onSearchChange, 
  sortBy, 
  onSortChange, 
  viewMode, 
  onViewModeChange,
  totalResults,
  onFilterToggle 
}) => {
  const [isSearchFocused, setIsSearchFocused] = useState(false);

  const sortOptions = [
    { value: 'newest', label: 'Más Reciente' },
    { value: 'oldest', label: 'Más Antiguo' },
    { value: 'title-asc', label: 'Título A-Z' },
    { value: 'title-desc', label: 'Título Z-A' },
  ];

  const viewModeOptions = [
    { value: 'grid', icon: 'Grid3X3', label: 'Vista de Cuadrícula' },
    { value: 'compact', icon: 'LayoutGrid', label: 'Vista Compacta' }
  ];

  const handleSearchSubmit = (e) => {
    e?.preventDefault();
    // Search is handled by onChange, but we can add additional logic here
  };

  return (
    <div className="bg-card border literary-border rounded-lg literary-shadow p-6 mb-6">
      {/* Search Bar */}
      <form onSubmit={handleSearchSubmit} className="mb-6">
        <div className="relative">
          <div className="absolute inset-y-0 left-0 pl-4 flex items-center pointer-events-none">
            <Icon 
              name="Search" 
              size={20} 
              className={`literary-transition ${
                isSearchFocused ? 'text-primary' : 'text-scholarly-gray'
              }`} 
            />
          </div>
          <Input
            type="search"
            placeholder="Buscar por título"
            value={searchQuery}
            onChange={(e) => onSearchChange(e?.target?.value)}
            onFocus={() => setIsSearchFocused(true)}
            onBlur={() => setIsSearchFocused(false)}
            className="pl-12 pr-4 py-3 text-base"
          />
          {searchQuery && (
            <button
              type="button"
              onClick={() => onSearchChange('')}
              className="absolute inset-y-0 right-0 pr-4 flex items-center text-scholarly-gray hover:text-primary literary-transition"
            >
              <Icon name="X" size={20} />
            </button>
          )}
        </div>
      </form>
      {/* Controls Row */}
      <div className="hidden lg:flex lg:flex-row lg:items-center lg:justify-between gap-4">
        {/* Left Side - Results and Filter Toggle */}
        <div className="flex flex-col gap-4 lg:flex-row lg:items-center lg:justify-between">

          <div className="flex items-center justify-between">
            <Button
                variant="outline"
                size="sm"
                onClick={onFilterToggle}
                className="lg:hidden font-cta"
            >
              <Icon name="Filter" size={16} className="mr-2" />
              Filtros
            </Button>

            <span className="text-sm text-scholarly-gray">
              {totalResults} resultados
            </span>
          </div>

          <Select
              options={sortOptions}
              value={sortBy}
              onChange={onSortChange}
              placeholder="Ordenar por"
              className="w-full lg:w-[200px]"
          />
        </div>


        {/* Right Side - Sort and View Controls */}
        <div className="flex items-center space-x-4">
          {/* Sort Dropdown */}
          <div className="flex items-center space-x-2">
            <Icon name="ArrowUpDown" size={16} className="text-scholarly-gray" />
            <Select
              options={sortOptions}
              value={sortBy}
              onChange={onSortChange}
              placeholder="Ordenar por"
              className="min-w-[180px]"
            />
          </div>

          {/* View Mode Toggle */}
          <div className="flex items-center bg-muted rounded-lg p-1">
            {viewModeOptions?.map((mode) => (
              <button
                key={mode?.value}
                onClick={() => onViewModeChange(mode?.value)}
                className={`p-2 rounded-md literary-transition ${
                  viewMode === mode?.value
                    ? 'bg-primary text-primary-foreground literary-shadow'
                    : 'text-scholarly-gray hover:text-primary hover:bg-primary/'
                }`}
                title={mode?.label}
              >
                <Icon name={mode?.icon} size={16} />
              </button>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default SearchAndSort;